import styled from 'styled-components';
import { Label, Container } from './Styles';

const InfoContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 28px;
  height: 28px;
  margin: 5px 0;
  cursor: pointer;
  border-radius: 22px;
  border: 2px solid var(--darkGrey);
  background: #fff;

  svg {
    min-width: 18px;
    path {
      fill: var(--darkGrey);
    }
  }
`;

const InfoBtn = ({ clickEvent }) => (
  <Container onClick={() => clickEvent()}>
    <InfoContainer>
      <svg
        className="info"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20.708 62.2"
      >
        <path
          d="M22.059,21.764,7.392,23.6l-.524,2.435,2.886.524c1.877.451,2.25,1.125,1.843,3l-4.729,22.2C5.632,57.5,7.547,60.2,12.043,60.2c3.492,0,7.537-1.61,9.375-3.827l.563-2.663a7.1,7.1,0,0,1-4.389,1.576c-1.761,0-2.4-1.237-1.95-3.414l6.417-30.109ZM22.5,8.4A6.4,6.4,0,1,1,16.1,2a6.4,6.4,0,0,1,6.4,6.4Z"
          transform="translate(-4.479)"
          strokeWidth="3"
        />
      </svg>
    </InfoContainer>
    <Label>Info</Label>
  </Container>
);

export default InfoBtn;
